import { render, staticRenderFns } from "./LessInfo.vue?vue&type=template&id=7fc3b5fc&scoped=true&"
import script from "./LessInfo.vue?vue&type=script&lang=js&"
export * from "./LessInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc3b5fc",
  null
  
)

export default component.exports